import { IAssignEntity } from "../basics/basics.models";

export class GetCwSelfAssessmentReviewResponse {
    cwSelfAssessmentId: number;
    cwSelfAssessmentGuid: string;
    assignedUserId: number;
    assignedTo: string;
    chapters: CwChapterClientModel[];
    statusHistory: CwSelfAssessmentStatusHistoryClientModel[];
    companies: CwCompanyModel[];
}

export interface CwCompanyModel {
    companyId: number;
    companyName: string;
}

export class CwChapterClientModel {
    sections: CwSectionClientModel[];
    guid: string;
    name: string;
    chapterIndex: number;
    cwSelfAssessmentGuid: string;
}

export interface CwSectionClientModel {
    name: string;
    description: string;
    isCompleted: boolean;
    questions: CwQuestionClientModel[];
    questionsCount: number;
    questionsAnsweredCount: number;
    sectionIndex: number;
    chapterIndex: number;
    chapterGuid: string;
}

export interface CwQuestionClientModel {
    question: string;
    answer: string;
    cwSelfAssessmentQuestionGuid: string;
    questionIndex: number;
    captionIndex: string;
    instructionsText: string;
    notesCount: number;
    isMlcRequirementSatisfied: boolean;
    choices: CwQuestionChoiceClientModel[];
}

export interface CwQuestionChoiceClientModel {
    id: number;
    name: string;
    sequence: number;
    isSelected: boolean;
}

export interface CwSelfAssessmentStatusHistoryClientModel {
    status: string;
    statusId: number;
    previousStatusId?: number;
    userFullName: string;
    userId: number;
    createdDate: Date;
}

export interface GetReviewCriteriaResponse {
    criterias: CriteriaModel[];
}

export interface CriteriaModel {
    code: string;
    name: string;
    description: string;
    passed: boolean;
    additionalDetails: string;
}

export enum CwsaStepEnum {
    FormData = 1,
    ReviewCriteria = 2,
    Correspondence = 3,
    Documents = 4,
    PrivateNotes = 5,
    EmailHistory = 6,
    HistoryTrail = 7
}

export enum CwsaStatusEnum {
    InProgress = 1,
    Submitted = 2,
    Completed = 3,
    UnderReview = 4,
    PendingReview = 5,
    AwaitingResponse = 6,
    Reassignment = 7,
    Accepted = 8,
    Rejected = 9,
    Cancelled = 10
}

export enum CwsaStatusNameEnum {
    Accepted = "Accepted",
    AwaitingResponse = "Awaiting Response",
    Completed = "Completed",
    InProgress = "In Progress",
    PendingReview = "Pending RightShip Review"
}

export interface GetAssignmentResponse {
    assignedEntity: IAssignEntity;
}

export interface SetAssignmentResponse {
    assignmentMismatch: boolean;
}

export interface SetAssignmentRequest {
    assignedTo?: number;
    assignmentComment?: string;
    previouslyAssignedTo?: number;
    cwSelfAssessmentGuid: string;
}

export interface GetCwStatusesResponse {
    statuses: CwsaStatusClientModel[];
}

export interface CwsaStatusClientModel {
    name: string;
    statusId: number;
}

export interface GetCwsaStatusesRequest {
    cwSelfAssessmentGuid: string;
}

export interface ChangeCwsaStatus {
    cwSelfAssessmentGuid: string;
    newStatusId: number;
    remarks?: string;
    subTaskTypeIds: number[];
}

export interface SendLegacyCwsaEmailRequest {
    message: string;
    legacyCwSelfAssessmentId: number;
    emails: any[];
    attachments: any[];
}

export interface SendLegacyCwsaEmailResponse {

}

export interface ChangeLegacyCwsaStatusRequest {
    legacyCwSelfAssessmentId: number;
    newStatus: string;
}

export interface ChangeLegacyCwsaStatusResponse {

}

export interface ChangeCwsaStatusResponse {
    isSuccessful: boolean;
}

export interface GetLegacyCwsaPdfLinkResponse {
    link: string;
}

export interface GetLegacyCwsaResponse {
    legacyCwsa: LegacyCwsaClientModel;
}

export interface LegacyCwsaClientModel {
    email: string;
    attachments: LegacyCwsaAttachmentClientModel[];
}

export interface LegacyCwsaAttachmentClientModel {
    documentName: string;
    legacyCwSelfAssessmentAttachmentId: string;
}

export interface CwsaEntityModel {
    privateNotesCount: number;
}